import {Datepicker} from '@ijavad805/react-datepicker';
import "./datepicker.scss"
import {useState} from "react";

const DatePicker = () => {
    const [value, setValue] = useState("");
    return (
        <>
            <Datepicker
                onChange={(val: any) => {
                    setValue(val.format())
                }}
                theme={"red"}
                input={<input readOnly placeholder='انتخاب کنید'/>}
            />
        </>
    );
}

export default DatePicker;